import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { staticStat } from '@/api/index';
import type {
  AggrStaticDeviceFieldAggrBody,
  AggrStaticDeviceFieldThrBody,
  AggrStaticPlaysBody,
} from '@/api/routes/static-stat/types';

// export const fetchAggrDevice = createAsyncThunk(
//   'stat/aggr/device',
//   async (payload: AggrDeviceBody, thunkAPI) => {
//     try {
//       const response = await statApi.getDevice(payload);
//       return response ? response.data : [];
//     } catch (e) {
//       if (e instanceof AxiosError) {
//         return thunkAPI.rejectWithValue(e.message);
//       }
//       throw e;
//     }
//   },
// );

export const fetchStaticAggrDeviceTimeFieldThr = createAsyncThunk(
  'stat/aggr/static-device-field-thr-time',
  async (payload: AggrStaticDeviceFieldThrBody, thunkAPI) => {
    try {
      const response = await staticStat.getDevicesCountByField(payload);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchStaticAggrDeviceMileageFieldThr = createAsyncThunk(
  'stat/aggr/static-device-field-thr-mileage',
  async (payload: AggrStaticDeviceFieldThrBody, thunkAPI) => {
    try {
      const response = await staticStat.getDevicesCountByField(payload);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchStaticAggrDeviceSumFieldAggr = createAsyncThunk(
  'stat/aggr/static-device-field-aggr-sum',
  async (payload: AggrStaticDeviceFieldAggrBody, thunkAPI) => {
    try {
      const response = await staticStat.getDeviceStatByAggr(payload);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchStaticAggrDeviceSumAdTimeFieldAggr = createAsyncThunk(
  'stat/aggr/static-device-field-aggr-sum-ad-time',
  async (payload: AggrStaticDeviceFieldAggrBody, thunkAPI) => {
    try {
      const response = await staticStat.getDeviceStatByAggr(payload);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

// export const fetchAggrDeviceAvgFieldAggr = createAsyncThunk(
//   'stat/aggr/device-field-aggr-avg',
//   async (payload: AggrDeviceFieldAggrBody, thunkAPI) => {
//     try {
//       const response = await statApi.getDeviceByAggr(payload);
//       return response ? response.data : [];
//     } catch (e) {
//       if (e instanceof AxiosError) {
//         return thunkAPI.rejectWithValue(e.message);
//       }
//       throw e;
//     }
//   },
// );

export const fetchStaticMileageAggrByDay = createAsyncThunk(
  'stat/aggr/static-device-field-aggr',
  async (payload: AggrStaticDeviceFieldAggrBody, thunkAPI) => {
    try {
      const response = await staticStat.getDeviceStatByAggr(payload);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchStaticAirtimeAggrByDay = createAsyncThunk(
  'stat/aggr/static-device-field-aggr',
  async (payload: AggrStaticDeviceFieldAggrBody, thunkAPI) => {
    try {
      const response = await staticStat.getDeviceStatByAggr(payload);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchStaticAggrPlaysByAd = createAsyncThunk(
  'stat/aggr/static-plays-by-ad',
  async (payload: AggrStaticPlaysBody, thunkAPI) => {
    try {
      const response = await staticStat.getPlaysByAd(payload);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchStaticAggrTotal = createAsyncThunk(
  'stat/aggr/static-plays-totals',
  async (payload: AggrStaticPlaysBody, thunkAPI) => {
    try {
      const response = await staticStat.getTotalPlaysByAd(payload);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchStaticDeviceByDay = createAsyncThunk(
  'stat/aggr/static-device-by-day',
  async (payload: AggrStaticPlaysBody, thunkAPI) => {
    try {
      const response = await staticStat.getStaticDeviceByDay(payload);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

